(function (window, document) {
  'use strict';

  var VERSION = '1.3.0';
  var html = document.documentElement;
  if (html.dataset.aionMeasurementVersion === VERSION) return;
  html.dataset.aionMeasurementVersion = VERSION;

  var EVENT_CONTRACT = 'aion-web-1.3';
  var ATTRIBUTION_KEY = 'aion_attribution_v1';
  var INTERNAL_KEY = 'aion_internal_traffic_v1';
  var MAX_PENDING = 50;
  var pending = [];
  var deliveredDepths = {};
  var attributionEmitted = false;

  var analyticsAllowed = function () {
    return Boolean(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
      window.Shopify.customerPrivacy.analyticsProcessingAllowed()
    );
  };

  var compact = function (object) {
    Object.keys(object).forEach(function (key) {
      if (object[key] === undefined || object[key] === null || object[key] === '') delete object[key];
    });
    return object;
  };

  var sanitizeCampaignValue = function (value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9._~-]/g, '')
      .slice(0, 120);
  };

  var safeLocation = function (value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.href);
      return (url.origin + url.pathname).slice(0, 500);
    } catch (_) {
      return '';
    }
  };

  var params = new URLSearchParams(window.location.search || '');
  try {
    if (params.get('aion_internal') === '1') window.sessionStorage.setItem(INTERNAL_KEY, '1');
    if (params.get('aion_internal') === '0') window.sessionStorage.removeItem(INTERNAL_KEY);
  } catch (_) {}

  var classifyTraffic = function () {
    var preview = Boolean(
      (window.Shopify && window.Shopify.designMode) ||
      params.has('preview_theme_id') ||
      params.has('_fd') ||
      /(^|\.)myshopify\.com$/i.test(window.location.hostname || '')
    );
    var internal = false;
    try { internal = window.sessionStorage.getItem(INTERNAL_KEY) === '1'; } catch (_) {}
    if (preview) return 'preview';
    if (internal) return 'internal';
    return 'external';
  };

  var trafficClass = classifyTraffic();
  html.dataset.aionTrafficClass = trafficClass;

  var currentAttribution = function () {
    var utm = {};
    var invalid = false;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      var original = params.get(key);
      if (!original) return;
      var cleaned = sanitizeCampaignValue(original);
      if (!cleaned) invalid = true;
      else utm[key] = cleaned;
    });
    var utmCount = Object.keys(utm).length;
    var status = invalid ? 'invalid' : (utmCount === 0 ? 'none' : (utm.utm_source && utm.utm_medium && utm.utm_campaign ? 'complete' : 'partial'));
    return compact(Object.assign({
      landing_page: String(window.location.pathname || '/').slice(0, 500),
      referrer: safeLocation(document.referrer),
      utm_status: status
    }, utm));
  };

  var readAttribution = function () {
    try { return JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_KEY) || '{}'); }
    catch (_) { return {}; }
  };

  var persistAttribution = function () {
    if (trafficClass !== 'external' || !analyticsAllowed()) return;
    try {
      var current = currentAttribution();
      var stored = readAttribution();
      if (!stored.first) stored.first = current;
      stored.last = current;
      stored.contract = EVENT_CONTRACT;
      window.sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(stored));
    } catch (_) {}
  };

  var deliver = function (payload) {
    window.dispatchEvent(new CustomEvent('aion:' + payload.event, { detail: payload }));
    if (trafficClass !== 'external') return;
    if (!analyticsAllowed()) {
      if (pending.length >= MAX_PENDING) pending.shift();
      pending.push(payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  var emit = function (name, detail) {
    deliver(compact(Object.assign({
      event: name,
      event_contract_version: EVENT_CONTRACT,
      page_path: String(window.location.pathname || '/').slice(0, 500),
      locale: document.documentElement.lang || 'de-CH',
      storefront_key: document.body ? (document.body.getAttribute('data-storefront-key') || 'unknown') : 'unknown',
      traffic_class: trafficClass
    }, detail || {})));
  };

  var flush = function () {
    if (trafficClass !== 'external' || !analyticsAllowed()) return;
    persistAttribution();
    if (!attributionEmitted) {
      attributionEmitted = true;
      var stored = readAttribution();
      emit('session_attribution', compact({
        first_source: stored.first && stored.first.utm_source,
        first_medium: stored.first && stored.first.utm_medium,
        first_campaign: stored.first && stored.first.utm_campaign,
        first_status: stored.first && stored.first.utm_status,
        last_source: stored.last && stored.last.utm_source,
        last_medium: stored.last && stored.last.utm_medium,
        last_campaign: stored.last && stored.last.utm_campaign,
        last_status: stored.last && stored.last.utm_status
      }));
    }
    var queued = pending.slice();
    pending.length = 0;
    queued.forEach(function (payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    });
  };

  window.AIONMeasurement = {
    version: VERSION,
    contract: EVENT_CONTRACT,
    emit: emit,
    analyticsAllowed: analyticsAllowed,
    trafficClass: trafficClass,
    classifyTraffic: classifyTraffic,
    sanitizeCampaignValue: sanitizeCampaignValue,
    getAttribution: function () { return analyticsAllowed() ? readAttribution() : {}; },
    currentAttribution: currentAttribution
  };

  document.addEventListener('visitorConsentCollected', flush);
  window.addEventListener('pageshow', flush);
  persistAttribution();

  emit('measurement_ready', {
    consent_state: analyticsAllowed() ? 'allowed' : 'pending',
    suppression_active: trafficClass !== 'external'
  });

  var visibleSeconds = 0;
  var engagementTimer = window.setInterval(function () {
    if (document.visibilityState === 'visible') visibleSeconds += 5;
    if (visibleSeconds >= 30) {
      window.clearInterval(engagementTimer);
      emit('engaged_30s', { engagement_seconds: 30, journey_stage: 'awareness' });
    }
  }, 5000);

  var measureScrollDepth = function () {
    var documentHeight = Math.max(document.documentElement.scrollHeight || 0, document.body ? document.body.scrollHeight || 0 : 0);
    var viewportBottom = (window.scrollY || 0) + (window.innerHeight || 0);
    var depth = documentHeight > 0 ? Math.min(100, Math.round((viewportBottom / documentHeight) * 100)) : 100;
    [25, 50, 75, 90].forEach(function (threshold) {
      if (depth >= threshold && !deliveredDepths[threshold]) {
        deliveredDepths[threshold] = true;
        emit('scroll_depth', { percent_scrolled: threshold, journey_stage: threshold >= 50 ? 'consideration' : 'awareness' });
      }
    });
  };
  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function () {
      scrollTicking = false;
      measureScrollDepth();
    });
  }, { passive: true });
  window.addEventListener('load', measureScrollDepth, { once: true });

  document.addEventListener('click', function (event) {
    var action = event.target.closest && event.target.closest('[data-aion-action]');
    if (!action) return;
    emit('click_aion_action', {
      action: String(action.getAttribute('data-aion-action') || 'unknown').slice(0, 80),
      destination_path: safeLocation(action.getAttribute('href')),
      journey_stage: String(action.getAttribute('data-aion-stage') || 'consideration').slice(0, 40)
    });
  });

  var vitals = { lcp: null, cls: 0, inp: null, ttfb: null, navigationType: '' };
  var vitalsReported = false;
  if (window.performance && typeof window.performance.getEntriesByType === 'function') {
    var navigationEntries = window.performance.getEntriesByType('navigation');
    if (navigationEntries.length) {
      vitals.ttfb = Math.round(navigationEntries[0].responseStart || 0);
      vitals.navigationType = navigationEntries[0].type || '';
    }
  }
  if ('PerformanceObserver' in window) {
    var supportedTypes = PerformanceObserver.supportedEntryTypes || [];
    if (supportedTypes.indexOf('largest-contentful-paint') > -1) {
      try {
        new PerformanceObserver(function (list) {
          var entries = list.getEntries();
          if (entries.length) vitals.lcp = Math.round(entries[entries.length - 1].startTime || 0);
        }).observe({ type: 'largest-contentful-paint', buffered: true });
      } catch (_) {}
    }
    if (supportedTypes.indexOf('layout-shift') > -1) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            if (!entry.hadRecentInput) vitals.cls += entry.value || 0;
          });
        }).observe({ type: 'layout-shift', buffered: true });
      } catch (_) {}
    }
    if (supportedTypes.indexOf('event') > -1) {
      try {
        var interactionDurations = {};
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            if (!entry.interactionId) return;
            interactionDurations[entry.interactionId] = Math.max(interactionDurations[entry.interactionId] || 0, entry.duration || 0);
          });
          Object.keys(interactionDurations).forEach(function (key) {
            vitals.inp = Math.max(vitals.inp || 0, interactionDurations[key]);
          });
        }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
      } catch (_) {}
    }
  }

  var reportVitals = function () {
    if (vitalsReported) return;
    vitalsReported = true;
    emit('web_vitals', compact({
      lcp_ms: vitals.lcp,
      cls: Math.round(vitals.cls * 10000) / 10000,
      inp_candidate_ms: vitals.inp ? Math.round(vitals.inp) : undefined,
      ttfb_ms: vitals.ttfb,
      navigation_type: vitals.navigationType || undefined,
      measurement_method: 'native_performance_observer_candidate'
    }));
  };
  window.addEventListener('pagehide', reportVitals, { once: true });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') reportVitals();
  });

  var relevant = document.querySelector('[data-b2b-page],[data-company-fit],[data-company-request-form]');
  if (relevant && !html.dataset.b2bAnalyticsRuntime) {
    var current = document.currentScript || document.querySelector('script[src*="b2b-analytics.js"]');
    if (current && current.src) {
      html.dataset.b2bAnalyticsRuntime = 'loading';
      var runtime = document.createElement('script');
      runtime.src = current.src.replace(/b2b-analytics\.js(?:\?.*)?$/, 'b2b-analytics-runtime.js');
      runtime.defer = true;
      runtime.onload = function () { html.dataset.b2bAnalyticsRuntime = 'ready'; };
      runtime.onerror = function () {
        html.dataset.b2bAnalyticsRuntime = 'error';
        emit('runtime_error', { runtime: 'b2b-analytics-runtime' });
      };
      document.head.appendChild(runtime);
    }
  }
})(window, document);
